import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Оплата по связке acquiring_pay_with_binding
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/Payment/99e4f24be96466dad78eef6d529b61c7
*/

export const makePaymentWithBinding = (providerId: number, params = {}): IRequest => ({
    uri: '/payment/card',
    withAuth: true,
    withProvider: true,
    method: 'POST',
    body: JSON.stringify(params),
    queryParams: {
        providerId,
    },
});
